export default {
  controlpacks: {
    title: "Control of packs delivery",
    storn: {
      modal: {
        title: "Reason for returning the pack"
      },
      card: {
        selectTypeStornPack: "Select type of packs storno",
        chooseReason: "Select the reason"
      },
      form: {
        typeStornId: {
          onlyBreakLink: "Only break the connection between pack and receipt",
          stornPack: "Storno the pack and all its receipts"
        }
      }
    },
    edit: {
      modal: {
        infoPack: "Pack info",
        compensationDisability: "Compensation for the visually impaired",
        socialSupplementInfo: "Social surcharge info",
        subsidyInfo: "Subsidy info"
      },
      form: {
        packnumber: {
          title: "Bank number of the pack"
        },
        datebank: {
          title: "Bank date"
        },
        codefirme: {
          title: "Sender"
        },
        accountSender: {
          title: "Sender account"
        },
        kindpay: {
          title: "Payment method"
        },
        quantity: {
          numberSubs: "Number of subscribers",
          numberReceipts: "Number of receipts"
        },
        countband: {
          numberSheets: "Number of sheets",
          numberCountband: "Number of parcels"
        },
        summa: {
          title: "Total"
        },
        sumprof: {
          title: "For services"
        },
        userid: {
          title: "Operator"
        }
      }
    },
    receipts: {
      modal: {
        title: "Pack info"
      },
      form: {
        summa: {
          title: "Total"
        },
        datebank: {
          title: "Bank date"
        },
        quantity: {
          title: "Receipts"
        },
        countband: {
          title: "Parcels"
        },
        reasonname: {
          title: "Reason for return"
        }
      }
    },
    controlPacksColumn: {
      headers: {
        packs: "Pack",
        payment: "Payment"
      }
    },
    packsCountbandColumn: {
      headers: {
        packsCountband: "Parcels"
      }
    },
    packsQuantityColumn: {
      headers: {
        packsQuantity: "Receipts"
      }
    },
    filterStatusOptions: {
      undeployed: "Not delivered",
      deployed: "Delivered",
      invalid: "Invalid"
    },
    statusPrepareChangeCheck: {
      title: "Storning"
    },
    statusAfterQuestion: {
      title: "Storning"
    },
    statusModifyPacksReceipts: {
      title: "Editing"
    },
    statusInfoPack: {
      title: "Successfull",
      pack: "Pack",
      wasDeliver: "was delivered"
    },
    stornModalSubmit: {
      returnReason: "Reason for return",
      allReceiptsDeleted:
        "All submitted receipts of selected pack will be deleted",
      continue: "Continue",
      confirm: {
        title: "Storning"
      }
    }
  }
};
